import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'eui-toolbar-item',
    templateUrl: './toolbar-item.component.html',
})
export class EuiToolbarItemComponent {
    @HostBinding('class') string = 'eui-toolbar-item';
}
